import { gql } from 'graphql-request'

const GET_PRODUCTS_HIGHEST_PRICE = gql`
  query getProductsHighestPrice($type: String!) {
    prices(
      limit: 1
      order_by: { price_subunit: desc }
      where: {
        _or: [
          {
            product: {
              _and: {
                creator: { account_status: { _eq: "active" } }
                type: { _eq: $type }
                status: { _eq: "active" }
                visible: { _eq: "true" }
                _not: { type: { _eq: "Product::FansiForBrands" } }
              }
            }
          }
          {
            price_contest_entry: {
              product: {
                _and: {
                  creator: { account_status: { _eq: "active" } }
                  status: { _eq: "active" }
                }
              }
            }
          }
        ]
      }
    ) {
      value: price_subunit
    }
  }
`

export default GET_PRODUCTS_HIGHEST_PRICE
